/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {dashCaseToCamelCase} from '../../util';

import {AnimationStyleNormalizer} from './animation_style_normalizer';
export class WebAnimationsStyleNormalizer extends AnimationStyleNormalizer {
/**
 * @param {?} propertyName
 * @param {?} errors
 * @return {?}
 */
normalizePropertyName(propertyName: string, errors: string[]): string {
    return dashCaseToCamelCase(propertyName);
  }
/**
 * @param {?} userProvidedProperty
 * @param {?} normalizedProperty
 * @param {?} value
 * @param {?} errors
 * @return {?}
 */
normalizeStyleValue(
      userProvidedProperty: string, normalizedProperty: string, value: string|number,
      errors: string[]): string {
    let /** @type {?} */ unit: string = '';
    const /** @type {?} */ strVal = value.toString().trim();

    if (DIMENSIONAL_PROP_MAP[normalizedProperty] && value !== 0 && value !== '0') {
      if (typeof value === 'number') {
        unit = 'px';
      } else {
        const /** @type {?} */ valAndSuffixMatch = value.match(/^[+-]?[\d\.]+([a-z]*)$/);
        if (valAndSuffixMatch && valAndSuffixMatch[1].length == 0) {
          errors.push(`Please provide a CSS unit value for ${userProvidedProperty}:${value}`);
        }
      }
    }
    return strVal + unit;
  }
}

const /** @type {?} */ DIMENSIONAL_PROP_MAP = makeBooleanMap(
    'width,height,minWidth,minHeight,maxWidth,maxHeight,left,top,bottom,right,fontSize,outlineWidth,outlineOffset,paddingTop,paddingLeft,paddingBottom,paddingRight,marginTop,marginLeft,marginBottom,marginRight,borderRadius,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,textIndent,perspective'
        .split(','));
/**
 * @param {?} keys
 * @return {?}
 */
function makeBooleanMap(keys: string[]): {[key: string]: boolean} {
  const /** @type {?} */ map: {[key: string]: boolean} = {};
  keys.forEach(key => map[key] = true);
  return map;
}



// WEBPACK FOOTER //
// ../../../../../packages/animations/browser/src/dsl/style_normalization/web_animations_style_normalizer.ts